<template>
  <div class="pt-20 p-5 w-11/12 overflow-y-scroll">
    <div class="mt-2">
      <div class="flex flex-col justify-between md:flex-row border-b border-gray-200 py-3">
        <div class="flex flex-col">
          <h1 class="flex text-3xl" >Daily Premium Access</h1>
          <p>Toggle on daily premium access to enable daily premium restriction to free users</p>
        </div>

        <div class="flex flex-col md:flex-row">
          <div class="w-64 font-bold h-10 mt-3 text-gray-800 flex justify-end">
            <label
              for="togglePremiumAccess"
              class="flex items-center cursor-pointer"
            >
              <!-- toggle -->
              <div class="relative">
                <!-- input -->
                <input id="togglePremiumAccess" type="checkbox" v-model="togglePremiumAccess" class="hidden" @change="onTogglePremiumAccess"  />
                <!-- line -->
                <div class="toggle__line w-10 h-4 bg-gray-400 rounded-full shadow-inner"></div>
                <!-- dot -->
                <div class="toggle__dot absolute w-6 h-6 bg-white rounded-full shadow inset-y-0 left-0"></div>
              </div>
              <!-- label -->
            </label>
          </div>
        </div>
      </div>
      <div class="flex flex-col md:flex-row border-b border-gray-200">
        <div class="w-64 font-bold h-6 mx-2 mt-3 text-gray-800">Number of Songs</div>
        <div class="flex-1 flex flex-col md:flex-row">
          <div class="w-full flex-1 mx-2">
            <div class="my-2 p-1 flex flex-col">
              <div class="flex-1" >
                <p v-if="$v.numberOfSongs.$dirty && !$v.numberOfSongs.required" class="text-red-500 text-xs italic text-left">Please fill Number Of Songs.</p>
                <p v-if="$v.numberOfSongs.$dirty && !$v.numberOfSongs.integer" class="text-red-500 text-xs italic text-left">Value must be an integer.</p>
                <p v-if="$v.numberOfSongs.$dirty && !$v.numberOfSongs.minValue" class="text-red-500 text-xs italic text-left">Value must be greater than zero.</p>
              </div>
              <div class="flex-1" >
                <input
                  type="text"
                  class="block border border-grey-light w-full p-3 rounded"
                  :class=" ($v.numberOfSongs.$dirty && !$v.numberOfSongs.required) || ($v.numberOfSongs.$dirty && !$v.numberOfSongs.integer) || ($v.numberOfSongs.$dirty && !$v.numberOfSongs.minValue) ? 'border-red-500' : ''"
                  name="name"
                  placeholder="Number of Songs"
                  v-model="numberOfSongs"
                  :disabled="!togglePremiumAccess"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="flex flex-col md:flex-row border-b border-gray-200">
        <div class="w-64 font-bold h-6 mx-2 mt-3 text-gray-800">Threshold Number</div>
        <div class="flex-1 flex flex-col md:flex-row">
          <div class="w-full flex-1 mx-2">
            <div class="my-2 p-1 flex flex-col">
              <div class="flex-1" >
                <p v-if="$v.thresholdNumber.$dirty && !$v.thresholdNumber.required" class="text-red-500 text-xs italic text-left">Please fill Threshold Number.</p>
                <p v-if="$v.thresholdNumber.$dirty && !$v.thresholdNumber.integer" class="text-red-500 text-xs italic text-left">Value must be an integer.</p>
                <p v-if="$v.thresholdNumber.$dirty && !$v.thresholdNumber.minValue" class="text-red-500 text-xs italic text-left">Value must be greater than zero.</p>
                <p v-if="$v.thresholdNumber.$dirty && !$v.thresholdNumber.thresholdLower" class="text-red-500 text-xs italic text-left">Threshold Number cannot be greater than Number of Songs</p>
              </div>
              <div class="flex-1" >
                <input
                  type="text"
                  class="block border border-grey-light w-full p-3 rounded"
                  :class=" ($v.thresholdNumber.$dirty && !$v.thresholdNumber.required) || ($v.thresholdNumber.$dirty && !$v.thresholdNumber.integer) || ($v.thresholdNumber.$dirty && !$v.thresholdNumber.minValue) ? 'border-red-500' : ''"
                  name="threshold"
                  placeholder="Threshold Number"
                  v-model="thresholdNumber"
                  :disabled="!togglePremiumAccess"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="flex flex-col md:flex-row border-b border-gray-200">
        <div class="w-64 font-bold h-6 mx-2 mt-3 text-gray-800">Reset Time</div>
        <div class="flex-1 flex flex-col md:flex-row">
          <div class="w-full flex-1 mx-2">
            <div class="my-2 p-1 flex flex-col">
              <div class="flex-1" >
                <p v-if="$v.resetTime.h.$dirty && !$v.resetTime.h.required" class="text-red-500 text-xs italic text-left">Please fill Reset Time Hours.</p>
                <p v-if="$v.resetTime.mm.$dirty && !$v.resetTime.mm.required" class="text-red-500 text-xs italic text-left">Please fill Reset Time Minutes</p>
                <p v-if="$v.resetTime.a.$dirty && !$v.resetTime.a.required" class="text-red-500 text-xs italic text-left">Please fill Reset Time Period</p>
              </div>
              <div class="flex flex-start" >
                <vue-timepicker :disabled="!togglePremiumAccess" v-model="resetTime" format="h:mm a" hide-clear-button close-on-complete></vue-timepicker>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div  class="flex flex-col md:flex-row ">
        <div class="w-1/2 font-bold h-auto mt-3 text-gray-800 flex flex-row">
          <button   class="text-sm  mx-2 w-full  focus:outline-none flex justify-center px-4 py-2 rounded font-bold cursor-pointer
                          bg-teal-700 text-teal-100
                          hover:bg-teal-100
                          hover:text-teal-700
                            border duration-200 ease-in-out
                          border-teal-600 transition" @click="save">Save
          </button>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import { validationMixin } from 'vuelidate';
import { required, email, maxLength, integer } from 'vuelidate/lib/validators';
import VueTimepicker from 'vue2-timepicker/src/vue-timepicker.vue';
import { mapActions, mapGetters } from 'vuex';

const greaterThanZero = value => value > 0;
const thresholdLower =
  (value, vm) => (Number(value) <= Number(vm.numberOfSongs));
export default {
  name: 'DailyPremiumAccess',
  mixins: [validationMixin],
  data: () => ({
    togglePremiumAccess: false,
    numberOfSongs: 0,
    thresholdNumber: 0,
    resetTime: {
      h: '',
      mm: '',
      a: '',
    },
  }),
  validations: {
    numberOfSongs: {
      required,
      integer,
      minValue: greaterThanZero,
    },
    thresholdNumber: {
      required,
      integer,
      minValue: greaterThanZero,
      thresholdLower,
    },
    resetTime: {
      h: { required },
      mm: { required },
      a: { required },
    },
  },
  computed: {
    ...mapGetters('NotificationModule', ['getErrorCode', 'getMessage', 'getStatus']),
  },
  async mounted() {
    const res = await this.requestDailyPremiumAccess();
    if (res) {
      if (isNaN(res.reset_time)) {
        const resetT = res.reset_time.split(' ');
        if (resetT[1]) {
          this.resetTime.a = resetT[1];
          const time = resetT[0].split(':');
          this.resetTime.h = time[0];
          this.resetTime.mm = time[1];
        }
      }
      this.numberOfSongs = Number(res.number_of_song);
      this.thresholdNumber = Number(res.threshold_number);
      this.togglePremiumAccess = res.status;
    }
  },
  methods: {
    ...mapActions('AppSettingModule', ['requestDailyPremiumAccess', 'requestSaveDailyPremiumAccess']),
    async save() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        await this.requestSaveDailyPremiumAccess({
          number_of_song: this.numberOfSongs,
          threshold_number: this.thresholdNumber,
          reset_time: `${this.resetTime.h}:${this.resetTime.mm} ${this.resetTime.a}`,
          status: this.togglePremiumAccess,
        });
        this.$v.$reset();
        if (this.getStatus == 200) {
          this.$swal('Settings Saved', '', 'success');
        } else if (this.getStatus === 400 && this.getErrorCode === 'error-save-premium-access') {
          this.$swal('Error', this.getMessage, 'error');
        }
      }
    },
    onTogglePremiumAccess() {
      if (!this.togglePremiumAccess) {
        this.$v.$reset();
      }
    },
  },
  components: { VueTimepicker },
};
</script>

<style scoped>
.toggle__dot {
  top: -.25rem;
  left: -.25rem;
  transition: all 0.3s ease-in-out;
}

input:checked ~ .toggle__dot {
  transform: translateX(100%);
  background-color: #48bb78;
}
</style>



// WEBPACK FOOTER //
// src/views/AppSetting/DailyPremiumAccess.vue